import { get } from 'lodash';
import { SectionType } from '../../types';
import * as defaults from '../defaults';
import { getRegionSpacing } from '../get-section-padding';
export function getFooterTweaksForSmallScreens() {
    return "\n    .html-email-body-section-footer > table > tbody > tr > td {\n      padding-bottom: 10px!important;\n    }\n  ";
}
export function getFooterTweaksInSimulatorForSmallScreens(_a) {
    var css = _a.css;
    var sectionSpacingObject = getRegionSpacing(css, SectionType.footer);
    var topPadding = sectionSpacingObject.padding.top;
    if (topPadding > 24) {
        topPadding = 24;
    }
    return "\n    .html-email-body-section-footer > table > tbody > tr > td {\n      padding-top: " + topPadding + "px!important;\n    }\n\n    .html-emails-footer-section > table > tbody > tr > td {\n      padding: 0!important;\n    }\n\n    .footer-top-spacer {\n      padding: 0!important;\n    }\n  ";
}
export function getFooterSeparatorForLargeScreensCss(_a) {
    var css = _a.css;
    var footerSeparatorColor = get(css, 'so-global-footer-separator.borderColor') ||
        defaults.defaultTextColor;
    return "\n    .html-emails-footer-section.show-border-right > table {\n      border-right: 1px solid " + footerSeparatorColor + " !important;\n    }\n\n    .html-emails-footer-section.show-border-left > table {\n      border-left: 1px solid " + footerSeparatorColor + " !important;\n    }\n\n    .html-emails-footer-section.bigger-column-height > table {\n      height: 67px!important;\n    }\n  ";
}
export function getFooterDividerCss() {
    return "\n    .html-emails-footer-divider {\n      display: none;\n    }\n  ";
}
export function getFooterDividerSmCss() {
    return "\n    .html-emails-footer-divider {\n      display: block !important;\n      padding-bottom: 18px!important;\n      padding-top: 18px!important;\n    }\n    .html-emails-footer-divider > * {\n      width: 70px!important;\n      border-width: 1px!important;\n    }\n    .html-emails-footer-site-with-mobile-divider {\n      padding-top:0px!important;\n      padding-bottom:0px!important;\n    }\n\n    .html-emails-footer-business-details-with-mobile-divider {\n      padding-bottom:0px!important;\n    }\n  ";
}
export function getMobilePlaceSmCss() {
    return "\n    .html-emails-footer-mobile-place-section > table > tbody > tr > td {\n      padding-top: 8px!important;\n      padding-bottom: 10px!important;\n    }\n\n    .html-emails-footer-mobile-place-section-no-divider > table > tbody > tr > td {\n      padding-top: 20px!important;\n      padding-bottom: 10px!important;\n    }\n\n    .html-emails-footer-mobile-place-divider {\n      padding-top: 0px!important;\n      padding-bottom: 18px!important;\n    }\n    .html-emails-footer-mobile-place-divider > * {\n      width: 70px!important;\n    }\n    .html-emails-footer-mobile-place-text {\n      padding: 0 20px!important;\n    }\n    .html-emails-footer-mobile-place-cta {\n      padding: 10px 20px 0!important;\n    }\n  ";
}
export function getFooterSectionStyle() {
    var smScreen = [
        getFooterTweaksForSmallScreens,
        getFooterDividerSmCss,
        getFooterTweaksInSimulatorForSmallScreens,
        getMobilePlaceSmCss,
    ];
    var lgScreen = getFooterSeparatorForLargeScreensCss;
    var allScreens = getFooterDividerCss;
    return {
        smScreen: smScreen,
        lgScreen: lgScreen,
        all: allScreens,
    };
}
//# sourceMappingURL=get-footer-section-style.js.map